import React, { useReducer } from 'react';
import { connect } from 'react-redux';
import noContentSrc from 'images/no_content.svg';
import noResultsSrc from 'images/content_no_results.svg';
import LinkButton from 'components/shared/LinkButton';
import { routes } from '../../constants/config';
import IndexDataView from '../shared/index/data_view';
import LessonCreationModal from './LessonCreationModal';

const NoContentBlankSlate = () => {
  const [modalVisible, toggleModalVisible] = useReducer(state => !state, false);
  return (
    <div className="mt-16 fz-bigger">
      <span className="c-brand-gray-dark">
        {t('contents.index.no_content.description_secondary')}
      </span>
      &nbsp;
      <LinkButton onClick={toggleModalVisible}>
        {t('contents.index.no_content.call_to_action')}
      </LinkButton>
      {modalVisible && <LessonCreationModal closeModal={toggleModalVisible} />}
    </div>
  );
};

const ContentDataView = props => {
  const blankSlates = {
    hasFailed: { icon: `${routes.ASSETS_BLANK_SLATES}/danger.svg` },
    noResults: {
      title: 'It’s Not You. It’s Me.',
      image: noResultsSrc,
      icon: `${routes.ASSETS_BLANK_SLATES}/filter.svg`,
      additionalDescription: (
        <span>
          Perhaps you are looking for something in the{' '}
          <a className="target" href={routes.ARCHIVES()}>
            archive
          </a>
          ?
        </span>
      ),
    },
    noContent: {
      image: noContentSrc,
      title: t('contents.index.no_content.title'),
      description: t('contents.index.no_content.description'),
      children: props.canCreateContent ? <NoContentBlankSlate /> : null,
    },
  };

  return (
    <IndexDataView
      {...props}
      blankSlates={blankSlates}
      tableHeaders={props.tableHeaders}
    />
  );
};

const mapStateToProps = state => ({
  canCreateContent: state.data.meta.currentUser.canCreateContent,
});

export default connect(mapStateToProps)(ContentDataView);
